// Consultas de UI de diario (daily_records, fuelings, maintenances, drivers)
// extraídas desde componentes. Regla SPEC-005: los componentes no llaman supabase.from().
import { supabase } from './client';

async function addDailyRecord(recordData) {
  return await supabase.from('daily_records').insert(recordData).select('id').single();
}

async function getDailyRecords(userId) {
  return await supabase.from('daily_records').select('*').eq('user_id', userId).order('date', { ascending: false });
}

async function updateDailyRecord(id, updates) {
  const { data, error } = await supabase.from('daily_records').update(updates).eq('id', id);
  return { data, error };
}

async function deleteDailyRecord(id) {
  return await supabase.from('daily_records').delete().eq('id', id);
}

async function deleteFueling(fuelingId) {
  return await supabase.from('fuelings').delete().eq('id', fuelingId);
}

async function getMaintenancesList(userId) {
  return await supabase
    .from('maintenances')
    .select('*')
    .eq('user_id', userId)
    .order('data', { ascending: false });
}

async function insertMaintenance(maintenanceData) {
  return await supabase.from('maintenances').insert(maintenanceData);
}

async function deleteMaintenance(id) {
  return await supabase.from('maintenances').delete().eq('id', id);
}

async function getDriverStatus(driverUid) {
  const res = await supabase
    .from('drivers')
    .select('status, is_approved')
    .eq('driver_uid', driverUid)
    .maybeSingle();

  if (!res.error && res.data) {
    if (res.data.is_approved === true && (!res.data.status || res.data.status === 'pending')) {
      res.data.status = 'active';
    }
  }
  return res;
}

export {
  addDailyRecord,
  getDailyRecords,
  updateDailyRecord,
  deleteDailyRecord,
  deleteFueling,
  getMaintenancesList,
  insertMaintenance,
  deleteMaintenance,
  getDriverStatus
};
